import { render, staticRenderFns } from "./CianElementConfigurableScaleTableColumn.vue?vue&type=template&id=17b6d7c6&scoped=true"
import script from "./CianElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
export * from "./CianElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
import style0 from "./CianElementConfigurableScaleTableColumn.vue?vue&type=style&index=0&id=17b6d7c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b6d7c6",
  null
  
)

export default component.exports